import React, { ReactElement } from 'react';

import { partnersLinks } from 'components/partners/partners-links';

import './partners-grid.scss';
import classNames from 'classnames';

interface PartnersGridProps {
    hideHeader?: boolean;
    largeTiles?: boolean;
}

const PartnersGrid: React.FC<PartnersGridProps> = ({ hideHeader, largeTiles = false }): ReactElement => (
    <div className="partners-grid container">
        {!hideHeader && (
            <h2 className="partners-grid__title">
                Partnerzy
            </h2>
        )}
        <div className={classNames('partners-grid__list', { 'partners-grid__list--large-tiles': largeTiles })}>
            {partnersLinks('partners-grid')}
        </div>
    </div>
);

export default PartnersGrid;
